import { render, staticRenderFns } from "./SuperadminNewEmployeeMail.vue?vue&type=template&id=1f73a608&scoped=true&"
import script from "./SuperadminNewEmployeeMail.vue?vue&type=script&lang=js&"
export * from "./SuperadminNewEmployeeMail.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminNewEmployeeMail.vue?vue&type=style&index=0&id=1f73a608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f73a608",
  null
  
)

export default component.exports